
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.categories-carousel__cont[data-section-id]').forEach(function(section) {
        const sectionId = section.dataset.sectionId;

        const navButtons = section.querySelectorAll('.categories-carousel__nav nav button');
        const infoCtas = section.querySelectorAll('.categories-carousel__info-cta');
        const categories = section.querySelectorAll('.categories-carousel__category');

        const navElement = section.querySelector('.categories-carousel__nav nav');
        function checkNavOverflow() {
            if (!navElement) return;
            if (navElement.scrollWidth > navElement.clientWidth) {
                navElement.classList.add('has-overflow');
            } else {
                navElement.classList.remove('has-overflow');
            }
        }
        checkNavOverflow();
        window.addEventListener('resize', checkNavOverflow);
        const swiperInstances = {};

    function shuffleArray(array) {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    }

    function shuffleSwiperSlides(categoryEl) {
        const swiperEl = categoryEl.querySelector('.categories_carousel_swiper');
        const navContainer = categoryEl.querySelector('.categories-carousel__navigation');
        if (!swiperEl) return;

        const wrapper = swiperEl.querySelector('.swiper-wrapper');
        const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
        const shuffledSlides = shuffleArray(slides);

        wrapper.innerHTML = '';
        shuffledSlides.forEach(slide => wrapper.appendChild(slide));

        const index = categoryEl.dataset.categoryIndex;
        if (swiperInstances[index]) {
            swiperInstances[index].destroy(true, true);
        }
        const paginationEl = categoryEl.querySelector('.categories-carousel__pagination');
        swiperInstances[index] = new Swiper(swiperEl, {
            slidesPerView: 1.3,
            slidesPerGroup: 1,
            initialSlide: 0,
            breakpoints: {
                600: {
                    slidesPerView: 2.3,
                    slidesPerGroup: 2
                },
                768: {
                    slidesPerView: 2.8,
                    slidesPerGroup: 2
                },
                900: {
                    slidesPerView: 3.3,
                    slidesPerGroup: 3
                },
                1150: {
                    slidesPerView: 3.8,
                    slidesPerGroup: 3
                },
            },
            spaceBetween: 20,
            watchSlidesProgress: true,
            observer: true,
            observeParents: true,
            navigation: navContainer ? {
                nextEl: navContainer.querySelector('.swiper-button-next'),
                prevEl: navContainer.querySelector('.swiper-button-prev'),
            } : false,
            pagination: paginationEl ? {
                el: paginationEl,
                type: 'bullets',
                clickable: true,
            } : false,
            on: {
                slideChange: function () {
                    if (this.pagination && this.pagination.render) {
                        this.pagination.render();
                        this.pagination.update();
                    }
                },
                touchMove: function () {
                    if (this.pagination && this.pagination.update) {
                        this.pagination.update();
                    }
                },
            },
        });
    }

    navButtons.forEach((button) => {
        button.addEventListener('click', function () {
            const index = this.dataset.categoryIndex;

            navButtons.forEach((btn) => btn.classList.remove('active'));
            infoCtas.forEach((cta) => cta.classList.remove('active'));
            categories.forEach((cat) => cat.classList.remove('active'));

            this.classList.add('active');
            const activeInfoCta = section.querySelector(`.categories-carousel__info-cta[data-category-index="${index}"]`);
            const activeCategory = section.querySelector(`.categories-carousel__category[data-category-index="${index}"]`);

            activeInfoCta?.classList.add('active');
            activeCategory?.classList.add('active');

            if (activeCategory) {
                shuffleSwiperSlides(activeCategory);
            }
        });
    });
    });
});
function initCarouselProducts() {
    if (typeof Swiper !== 'undefined') {
        document.querySelectorAll('.categories-carousel__category').forEach((category) => {
            const swiperEl = category.querySelector('.categories_carousel_swiper');
            const navContainer = category.querySelector('.categories-carousel__navigation');
            if (!swiperEl || !navContainer) return;

            const paginationEl = category.querySelector('.categories-carousel__pagination');
            new Swiper(swiperEl, {
                slidesPerView: 1.3,
                slidesPerGroup: 1,
                breakpoints: {
                    600: {
                        slidesPerView: 2.3,
                        slidesPerGroup: 2
                    },
                    768: {
                        slidesPerView: 2.8,
                        slidesPerGroup: 2
                    },
                    900: {
                        slidesPerView: 3.3,
                        slidesPerGroup: 3
                    },
                    1150: {
                        slidesPerView: 3.8,
                        slidesPerGroup: 3
                    },
                },
                spaceBetween: 20,
                watchSlidesProgress: true,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: navContainer.querySelector('.swiper-button-next'),
                    prevEl: navContainer.querySelector('.swiper-button-prev'),
                },
                pagination: paginationEl ? {
                    el: paginationEl,
                    type: 'bullets',
                    clickable: true,
                } : false,
                on: {
                    slideChange: function () {
                        if (this.pagination && this.pagination.render) {
                            this.pagination.render();
                            this.pagination.update();
                        }
                    },
                    touchMove: function () {
                        if (this.pagination && this.pagination.update) {
                            this.pagination.update();
                        }
                    },
                },
            });
        });
    } else {
        setTimeout(initCarouselProducts, 100);
    }
}

initCarouselProducts();